import apiExcel from '@/api/excel'

const state = {
  error: null,
  isSubmitting: false,
}

export const mutationTypes = {
  excelCalendarPlanStart: '[excel] excel calendar plan start',
  excelCalendarPlanSuccess: '[excel] excel calendar plan success',
  excelCalendarPlanFailure: '[excel] excel calendar plan failure',
}

export const actionTypes = {
  excelCalendarPlan: '[excel] calendar plan excel',
  excelCompetitionCalendarPlan: '[excel] calendar competition plan excel',
}

const mutations = {
  [mutationTypes.excelCalendarPlanStart](state) {
    state.isSubmitting = true
  },

  [mutationTypes.excelCalendarPlanSuccess](state) {
    state.isSubmitting = false
  },

  [mutationTypes.excelCalendarPlanFailure](state, payload) {
    state.error = payload
    state.isSubmitting = false
  },
}

const actions = {
  [actionTypes.excelCalendarPlan](context, {id}) {
    context.commit(mutationTypes.excelCalendarPlanStart)
    return new Promise((resolve) => {
      apiExcel
        .calendarPlan(id)
        .then((response) => {
          context.commit(mutationTypes.excelCalendarPlanSuccess)
          const file = new Blob([response.data], {
            type: response.headers['content-type'],
          })

          const link = URL.createObjectURL(file)
          resolve(link)
        })
        .catch((resolve) => {
          context.commit(
            mutationTypes.excelCalendarPlanFailure,
            resolve.response.data.errors
          )
        })
    })
  },

  [actionTypes.excelCompetitionCalendarPlan](context, {id}) {
    context.commit(mutationTypes.excelCalendarPlanStart)
    return new Promise((resolve) => {
      apiExcel
        .competitionCalendarPlan(id)
        .then((response) => {
          context.commit(mutationTypes.excelCalendarPlanSuccess)
          const file = new Blob([response.data], {
            type: response.headers['content-type'],
          })

          const link = URL.createObjectURL(file)
          resolve(link)
        })
        .catch((resolve) => {
          context.commit(
            mutationTypes.excelCalendarPlanFailure,
            resolve.response.data.errors
          )
        })
    })
  },
}

export default {
  state,
  mutations,
  actions,
}
